export const ANALYTICS_EVENTS = Object.freeze({
  SITE_PAGE_VIEW: "site.page_view",
  SITE_CTA_CLICKED: "site.cta_clicked",
  AUTH_GATE_OPENED: "auth.gate_opened",
  AUTH_COMPLETED: "auth.completed",
  AUTH_CTA_CLICKED: "auth.cta_clicked",
  TRIAL_VIEWED: "trial.viewed",
  TRIAL_STARTED: "trial.started",
  PROJECT_LOAD_STARTED: "project.load_started",
  PROJECT_LOAD_COMPLETED: "project.load_completed",
  PROJECT_LOAD_FAILED: "project.load_failed",
  PROJECT_CREATED: "project.created",
  PROJECT_OPENED: "project.opened",
  PROJECT_PERFORMANCE_LOAD: "project.performance_load",
  TEMPLATE_PICKER_OPENED: "template.picker_opened",
  TEMPLATE_APPLIED: "template.applied",
  PRESET_APPLIED: "preset.applied",
  PRESET_SAVED: "preset.saved",
  PRESET_DELETED: "preset.deleted",
  ONBOARDING_ACTIVATION: "onboarding.activation",
  ONBOARDING_COACHMARK_SHOWN: "onboarding.coachmark_shown",
  ONBOARDING_COACHMARK_DISMISSED: "onboarding.coachmark_dismissed",
  EXPORT_STARTED: "export.started",
  EXPORT_COMPLETED: "export.completed",
  EXPORT_FAILED: "export.failed",
  EXPORT_BLOCKED: "export.blocked",
  SHARE_OPENED: "share.opened",
  SHARE_LINK_ENABLED: "share.link_enabled",
  SHARE_LINK_DISABLED: "share.link_disabled",
  SHARE_LINK_REGENERATED: "share.link_regenerated",
  SHARE_BUTTON_CLICKED: "share_button_clicked",
  SHARE_AUTH_PROMPT_OPENED: "share_auth_prompt_opened",
  SHARE_AUTH_COMPLETED_RETURNED: "share_auth_completed_returned",
  PUBLISH_MODAL_OPENED: "publish_modal_opened",
  PUBLISH_MODAL_STATE_VIEWED: "publish_modal_state_viewed",
  SHARE_LINK_COPIED: "share_link_copied",
  PUBLISH_LINK_COPIED: "publish_link_copied",
  PUBLISH_SHARE_OPENED: "publish_share_opened",
  PUBLISH_SHARE_NATIVE_USED: "publish_share_native_used",
  PUBLISH_SHARE_CHANNEL_SELECTED: "publish_share_channel_selected",
  PUBLISH_SHARE_COPY_CLICKED: "publish_share_copy_clicked",
  PUBLISHED_SNAPSHOT_CREATED: "published_snapshot_created",
  PUBLISHED_SNAPSHOT_REPUBLISHED: "published_snapshot_republished",
  PUBLISHED_SNAPSHOT_REVOKED: "published_snapshot_revoked",
  PUBLISH_REPUBLISHED: "publish_republished",
  PUBLISH_DISABLED: "publish_disabled",
  PUBLISHED_SNAPSHOT_VIEWED: "published_snapshot_viewed",
  PUBLISHED_SNAPSHOT_CTA_CLICKED: "published_snapshot_cta_clicked",
  PUBLISHED_SNAPSHOT_TEMPLATE_OPEN_STARTED: "published_snapshot_template_open_started",
  PUBLISHED_SNAPSHOT_TEMPLATE_OPEN_COMPLETED: "published_snapshot_template_open_completed",
  PUBLISHED_SNAPSHOT_CREATE_STARTED: "published_snapshot_create_started",
  PUBLISHED_SNAPSHOT_CREATE_COMPLETED: "published_snapshot_create_completed",
  PUBLIC_VIEW_CTA_CLICKED: "public_view_cta_clicked",
  PUBLIC_VIEW_TEMPLATE_STARTED: "public_view_template_started",
  PUBLIC_VIEW_TEMPLATE_COMPLETED: "public_view_template_completed",
  PUBLIC_VIEW_CREATE_STARTED: "public_view_create_started",
  ATTRIBUTION_BADGE_CLICKED: "attribution_badge_clicked",
  PAYWALL_SHOWN: "paywall.shown",
  PAYWALL_CTA_CLICKED: "paywall.cta_clicked",
  BILLING_PAGE_VIEWED: "billing.page_viewed",
  BILLING_CHECKOUT_STARTED: "billing.checkout_started",
  BILLING_CHECKOUT_SUCCESS: "billing.checkout_success",
  BILLING_CHECKOUT_CANCELED: "billing.checkout_canceled",
  BILLING_CHECKOUT_FAILED: "billing.checkout_failed",
  TIMELINE_PERFORMANCE_INTERACTION: "timeline.performance_interaction",
});

export const ANALYTICS_REQUIRED_CATEGORIES = Object.freeze([
  "site",
  "auth",
  "trial",
  "project",
  "template",
  "preset",
  "onboarding",
  "export",
  "share",
  "paywall",
  "billing",
]);
